import React from "react";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="mt-6 rounded-2xl border border-rose/30 bg-white p-4 text-left" data-id="element-58" data-mp="2l5pq09ffuee5">
      <div className="flex items-center justify-between gap-3" data-id="element-59" data-mp="2q3r4eh1x5pja">
        <p className="flex items-center gap-1.5 text-sm font-bold text-ink" data-id="element-60" data-mp="2q1wjh2qndxf7">
          <FlameIcon className="h-4 w-4 text-rose" aria-hidden="true" data-id="element-61" data-mp="2b56xyrdpzrl5" />
          Only <span className="text-rose" data-id="element-62" data-mp="2g6w9s98ro9aa">{SPOTS_LEFT} spots</span> left at $27
        </p>
        <span className="text-sm font-extrabold text-rose" data-id="element-63" data-mp="226ll9cuxj6sa">{Math.round(filled)}%</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-blush" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-64" data-mp="274n0tnt5cnz0">
        <div className="scarcity-stripes h-full rounded-full bg-rose" style={{
        width: `${filled}%`
      }} data-id="element-65" data-mp="5bfo8m4x4kgt" />
      </div>
      <p className="mt-2 text-xs text-muted" data-id="element-66" data-mp="2zl9qypmukgrb">
        When the promotional spots run out, the price returns to its regular value.
      </p>
    </div>;
}